export function initBasket() {
	// ── Shared add-to-cart feedback: confirmation overlay + live basket badge ──
	const msfCartFeedback = (function () {
		let overlay;

		function ensureOverlay() {
			if (overlay) {
				return;
			}
			overlay = document.createElement('div');
			overlay.className = 'msf-cart-overlay';
			overlay.hidden = true;
			overlay.innerHTML =
				'<div class="msf-cart-overlay__backdrop"></div>' +
				'<div class="msf-cart-overlay__dialog">' +
				'<button type="button" class="msf-cart-overlay__close" aria-label="Close">&times;</button>' +
				'<div class="msf-cart-overlay__body"></div></div>';
			document.body.appendChild(overlay);
			overlay.querySelector('.msf-cart-overlay__backdrop').addEventListener('click', closeOverlay);
			overlay.querySelector('.msf-cart-overlay__close').addEventListener('click', closeOverlay);
		}

		function openOverlay(html) {
			ensureOverlay();
			overlay.querySelector('.msf-cart-overlay__body').innerHTML = html;
			// "Continue shopping" should dismiss and keep the user on the page
			const cont = overlay.querySelector('.woocommerce-message .btn-light');
			if (cont) {
				cont.addEventListener('click', function (e) {
					e.preventDefault();
					closeOverlay();
				});
			}
			overlay.hidden = false;
			document.body.classList.add('msf-cart-overlay-open');
		}

		function closeOverlay() {
			if (overlay) {
				overlay.hidden = true;
				document.body.classList.remove('msf-cart-overlay-open');
			}
		}

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				closeOverlay();
			}
		});

		function applyFragments(fragments) {
			if (!fragments) {
				return;
			}
			Object.keys(fragments).forEach(function (selector) {
				document.querySelectorAll(selector).forEach(function (el) {
					const tmp = document.createElement('div');
					tmp.innerHTML = fragments[selector];
					if (tmp.firstElementChild) {
						el.replaceWith(tmp.firstElementChild);
					}
				});
			});
		}

		function handleResponse(res) {
			if (res && res.success && res.data) {
				applyFragments(res.data.fragments);
				const hasItems = res.data.cart_count > 0;
				document.querySelectorAll('.cart-contents').forEach(function (a) {
					a.classList.toggle('is-empty', !hasItems);
				});
				openOverlay(res.data.notices);
			} else if (res && res.data && res.data.notices) {
				openOverlay(res.data.notices);
			}
		}

		return { handleResponse: handleResponse };
	})();

	// ── AJAX add to cart: single-product form ──
	(function initAjaxAddToCart() {
		if (typeof msfCart === 'undefined') {
			return;
		}

		const form = document.querySelector('.product-detail__cart form.cart');
		if (!form) {
			return;
		}

		form.addEventListener('submit', function (e) {
			// Variable products need a chosen variation; let WooCommerce handle
			// the empty case with its own validation message.
			const variationField = form.querySelector('input[name="variation_id"]');
			if (variationField && !parseInt(variationField.value, 10)) {
				return;
			}

			e.preventDefault();

			const button = form.querySelector('.single_add_to_cart_button');
			if (button) {
				button.classList.add('loading');
			}

			let productId = (form.querySelector('input[name="product_id"]') || {}).value;
			if (!productId) {
				const addField = form.querySelector('[name="add-to-cart"]');
				productId = addField ? addField.value : '';
			}

			const data = new FormData(form);
			// Drop the native add-to-cart key so WooCommerce's wp_loaded form
			// handler doesn't add the item and 302-redirect before our handler runs.
			data.delete('add-to-cart');
			data.append('action', 'msf_add_to_cart');
			data.append('nonce', msfCart.nonce);
			if (productId) {
				data.append('product_id', productId);
			}

			fetch(msfCart.ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (button) {
						button.classList.remove('loading');
					}
					msfCartFeedback.handleResponse(res);
				})
				.catch(function () {
					if (button) {
						button.classList.remove('loading');
					}
					form.submit();
				});
		});
	})();

	// ── AJAX add to cart: product-row / related-products buttons ──
	(function initRowAddToCart() {
		if (typeof msfCart === 'undefined') {
			return;
		}

		document.addEventListener('click', function (e) {
			const btn = e.target.closest('.js-msf-add-to-cart');
			if (!btn) {
				return;
			}

			const productId = btn.getAttribute('data-product_id');
			if (!productId) {
				return;
			}

			e.preventDefault();
			btn.classList.add('loading');

			const data = new FormData();
			data.append('action', 'msf_add_to_cart');
			data.append('nonce', msfCart.nonce);
			data.append('product_id', productId);
			data.append('quantity', btn.getAttribute('data-quantity') || '1');

			fetch(msfCart.ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
				.then(function (r) { return r.json(); })
				.then(function (res) {
					btn.classList.remove('loading');
					msfCartFeedback.handleResponse(res);
				})
				.catch(function () {
					btn.classList.remove('loading');
					if (btn.href) {
						window.location.href = btn.href;
					}
				});
		});
	})();

	// ── AJAX remove from basket: drop the line, refresh totals + badge ──
	(function initAjaxCartRemove() {
		if (typeof msfCart === 'undefined') {
			return;
		}

		const cartForm = document.querySelector('.woocommerce-cart-form');
		if (!cartForm) {
			return;
		}

		cartForm.addEventListener('click', function (e) {
			const link = e.target.closest('a.remove');
			if (!link) {
				return;
			}

			const key = new URL(link.href, window.location.origin).searchParams.get('remove_item');
			if (!key) {
				return;
			}

			e.preventDefault();
			const row = link.closest('.woocommerce-cart-form__cart-item');
			link.classList.add('loading');

			const data = new FormData();
			data.append('action', 'msf_remove_cart_item');
			data.append('nonce', msfCart.nonce);
			data.append('cart_item_key', key);

			fetch(msfCart.ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (!res || !res.success) {
						window.location.href = link.href;
						return;
					}
					// Empty basket: reload so WooCommerce renders its empty-cart state.
					if (res.data.cart_empty) {
						window.location.reload();
						return;
					}
					if (row) {
						row.remove();
					}
					// Swap the order summary (totals + conditional delivery line).
					const summary = document.querySelector('.msf-order-summary');
					if (summary && res.data.summary) {
						const tmp = document.createElement('div');
						tmp.innerHTML = res.data.summary;
						if (tmp.firstElementChild) {
							summary.replaceWith(tmp.firstElementChild);
						}
					}
					// The CTA label flips when the last physical item is removed.
					const cta = document.querySelector('.basket__actions button[name="msf_basket_submit"]');
					if (cta && res.data.cta_label) {
						cta.textContent = res.data.cta_label;
					}
					document.querySelectorAll('.cart-contents').forEach(function (a) {
						a.classList.toggle('is-empty', !(res.data.cart_count > 0));
					});
				})
				.catch(function () {
					window.location.href = link.href;
				});
		});
	})();

	// ── Basket: reveal nominated delivery date/time when the checkbox is ticked ──
	(function initNominateDelivery() {
		document.addEventListener('change', function (e) {
			const toggle = e.target.closest('.js-nominate-delivery');
			if (!toggle) {
				return;
			}
			const block = toggle.closest('.msf-message-block');
			const fields = block && block.querySelector('.js-nominate-fields');
			if (fields) {
				fields.hidden = !toggle.checked;
			}
		});
	})();

	// ── Basket: nominated date/time — mirror the offcanvas booking pickers ──
	(function initNominateWidgets() {
		if (window.flatpickr) {
			document.querySelectorAll('.js-msf-date').forEach(function (input) {
				if (input._mowgliFp) {
					return;
				}
				input._mowgliFp = window.flatpickr(input, {
					minDate: 'today',
					maxDate: input.dataset.maxdate || null,
					dateFormat: 'Y-m-d',
					altInput: true,
					altFormat: 'd/m/Y',
					disableMobile: true,
					monthSelectorType: 'static',
					static: true
				});
			});
		}
		if (window.Choices) {
			document.querySelectorAll('.js-msf-time').forEach(function (select) {
				if (select._mowgliChoices) {
					return;
				}
				select._mowgliChoices = new Choices(select, { searchEnabled: false, shouldSort: false, itemSelectText: '' });
			});
			document.querySelectorAll('.js-msf-country').forEach(function (select) {
				if (select._mowgliChoices) {
					return;
				}
				select._mowgliChoices = new Choices(select, { searchEnabled: true, shouldSort: false, itemSelectText: '' });
			});
		}
	})();

	// ── Basket: shipping-method radios update the order total live ──
	(function initShippingMethod() {
		document.addEventListener('change', function (e) {
			const radio = e.target.closest('.js-msf-shipping');
			if (!radio) {
				return;
			}
			const data = new FormData();
			data.append('action', 'msf_set_shipping_method');
			data.append('nonce', msfCart.nonce);
			data.append('shipping_method', radio.value);

			fetch(msfCart.ajaxUrl, { method: 'POST', body: data, credentials: 'same-origin' })
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (!res || !res.success || !res.data.summary) {
						return;
					}
					const summary = document.querySelector('.msf-order-summary');
					if (summary) {
						const tmp = document.createElement('div');
						tmp.innerHTML = res.data.summary;
						if (tmp.firstElementChild) {
							summary.replaceWith(tmp.firstElementChild);
						}
					}
				});
		});
	})();
}
